import React, {Dispatch, SetStateAction} from "react";
import Button from "@awsui/components-react/button";
import {useMutation} from "react-query";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import getRiderSynonyms from "api/getRiderSynonyms";
import Box from "@awsui/components-react/box";
import parseRiders from "pages/admin/util/parseRiders";
import Rider from "model/Rider";
import {useAuth} from "hooks/useAuth";
import RiderAndSynonyms from "model/RiderAndSynonyms";


interface GetRiderSynonymsButtonProps {
    ridersText: string;
    setRidersText: Dispatch<SetStateAction<string>>;
    buttonEnabled: boolean;
    setButtonEnabled: Dispatch<SetStateAction<boolean>>;
    setSubmitMessage: Dispatch<SetStateAction<FlashbarProps.MessageDefinition | undefined>>;
    setRiderSynonyms: Dispatch<SetStateAction<RiderAndSynonyms[] | undefined>>;
}

const GetRiderSynonymsButton: React.FC<GetRiderSynonymsButtonProps> = (props) => {

    const ridersText = props.ridersText;

    const [{user}] = useAuth();

    const {
        mutate: getRiderSynonymsMutation,
        isLoading: getRiderSynonymsIsLoading
    } = useMutation<RiderAndSynonyms[], Error, Rider[]>((riders: Rider[]) => getRiderSynonyms(riders, user?.token), {
            onSuccess: (riderSynonyms: RiderAndSynonyms[]) => {
                props.setRiderSynonyms(riderSynonyms);
            },
            onError: () => {
                props.setSubmitMessage({
                    header: "Error when getting rider synonyms",
                    type: "error",
                    content: "Try to refresh the page.",
                })
            },
            onSettled: () => {
                props.setButtonEnabled(false);
                props.setRidersText("");
            }
        }
    );

    const submitRiders = () => {
        getRiderSynonymsMutation(parseRiders(ridersText));
    }

    return (
        <Box float="right">
            <Button
                disabled={!props.buttonEnabled || (ridersText === "")}
                iconAlign="left"
                loading={getRiderSynonymsIsLoading}
                variant="primary"
                onClick={submitRiders}
            >
                Submit
            </Button>
        </Box>
    );
};

export default GetRiderSynonymsButton;
